import { getCredentials } from "@connect/credentials-storage";

export async function customerApiHeaders(
  clientHeaders: Record<string, string>,
): Promise<Record<string, string>> {
  const { devPlatformAccessToken } = await getCredentials();
  if (!devPlatformAccessToken) {
    throw new Error("missing_dev_platform_access_token");
  }

  return {
    ...clientHeaders,
    Authorization: `Bearer ${devPlatformAccessToken}`,
  };
}
